import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { authFetch } from '../../services/auth';

const DatabaseTest: React.FC = () => {
  const [testing, setTesting] = useState(false);
  const [testMessage, setTestMessage] = useState('');

  const handleTestConnection = async () => {
    if (!testing) {
      setTesting(true);
      setTestMessage('');
      
      try {
        const response = await authFetch('/test-db');
        const data = await response.json();
        
        if (response.ok) {
          setTestMessage(`✓ Database connection successful: ${JSON.stringify(data.results)}`);
        } else {
          setTestMessage(`✗ Connection failed: ${data.error}`);
        }
      } catch (error) {
        console.error('Database test error:', error);
        setTestMessage(`✗ Connection error: ${(error as Error).message}`);
      } finally {
        setTesting(false);
        setTimeout(() => setTestMessage(''), 10000);
      }
    }
  };

  return (
    <div>
      <Form.Text className="text-muted d-block mb-2">
        Test the Hyperdrive database connection to verify RDS connectivity.
      </Form.Text>
      <Button
        variant="info"
        onClick={handleTestConnection}
        disabled={testing}
        className="mb-2"
      >
        {testing ? 'Testing...' : 'Test Database Connection'}
      </Button>
      {testMessage && (
        <Alert
          variant={testMessage.startsWith('✓') ? 'success' : 'danger'}
          className="mt-2 mb-0"
        >
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{testMessage}</pre>
        </Alert>
      )}
    </div>
  );
};

export default DatabaseTest;